import { createSelector } from 'redux-orm';

import orm from '../orm';
import { selectPath } from './router';

export const selectPointSystemForCurrentBoard = createSelector(
  orm,
  (state) => selectPath(state).boardId,
  ({ Board }, boardId) => {
    if (!boardId) {
      return null;
    }

    const boardModel = Board.withId(boardId);
    if (!boardModel) {
      return null;
    }

    const pointSystemModel = boardModel.pointSystems.first();
    return pointSystemModel ? pointSystemModel.ref : null;
  },
);

export const makeSelectPointSystemByBoardId = () =>
  createSelector(
    orm,
    (_, boardId) => boardId,
    ({ Board }, boardId) => {
      if (!boardId) {
        return null;
      }

      const boardModel = Board.withId(boardId);
      if (!boardModel) {
        return null;
      }

      const pointSystemModel = boardModel.pointSystems.first();
      return pointSystemModel ? pointSystemModel.ref : null;
    },
  );

export default {
  selectPointSystemForCurrentBoard,
  makeSelectPointSystemByBoardId,
};

